import { createSelector, createFeatureSelector } from '@ngrx/store';
import {
	customerDetailAdapter,
	CustomerDetailsState,
	customerDetailFeatureKey,
} from './customer-detail.reducer';
import { customerToCustomerForm } from '../customer-detail.utility';

export const getCustomerDetailState = createFeatureSelector<
	CustomerDetailsState
>(customerDetailFeatureKey);

const { selectEntities } = customerDetailAdapter.getSelectors();

export const getLoadingStatus = createSelector(
	getCustomerDetailState,
	(state: CustomerDetailsState) => state.isLoading
);

export const getTitle = createSelector(
	getCustomerDetailState,
	(state: CustomerDetailsState) =>
		state.selectedCustomerId > 0 ? 'Edit Customer' : 'Create Customer'
);

export const getAllCustomerEntities = createSelector(
	getCustomerDetailState,
	selectEntities
);

export const getCustomerEntity = (id: number) =>
	createSelector(getAllCustomerEntities, (entities) => entities[id]);

export const getSelectedCustomerId = createSelector(
	getCustomerDetailState,
	(state: CustomerDetailsState) => state.selectedCustomerId
);

export const getCloseAfterSaving = createSelector(
	getCustomerDetailState,
	(state: CustomerDetailsState) => !state.shouldStayOnPage
);

export const getRailroads = createSelector(
	getCustomerDetailState,
	(state) => state.railroads
);

export const getRwics = createSelector(
	getCustomerDetailState,
	(state) => state.rwics
);

export const getJobs = createSelector(
	getCustomerDetailState,
	(state) => state.jobs
);

export const getIsSaving = createSelector(
	getCustomerDetailState,
	(state: CustomerDetailsState) => state.isSaving
);

export const getError = createSelector(
	getCustomerDetailState,
	(state: CustomerDetailsState) => state.error
);

export const getShouldSaveButtonShake = createSelector(
	getCustomerDetailState,
	(state: CustomerDetailsState) => state.error && !state.shouldStayOnPage
);

export const getSelectedCustomer = createSelector(
	getAllCustomerEntities,
	getSelectedCustomerId,
	(customerEntities, customerId) => customerEntities[customerId]
);

export const getSelectedCustomerForm = createSelector(
	getSelectedCustomer,
	(customer) => customerToCustomerForm(customer)
);
